import AbstractDataAttributeBehaviour from "./abstract-data-attribute-behaviour";

/**
 * Example usage
 * <a href="#section-1" data-hash-link data-hash-link-config='{"click": true, "scroll": true}'>Link</a>
 */
export default class HashBehaviour extends AbstractDataAttributeBehaviour {
    attrNames = {
        container: 'data-hash-link',
        config: 'data-hash-link-config'
    };

    defaultConfig = {
        click: true,
        scroll: true
    };

    getContainerSelector = () => '[' + this.attrNames.container + ']';

    getConfig = (container) => {
        let hashConfig = JSON.parse(container.getAttribute(this.attrNames.config));
        return {...this.defaultConfig, ...hashConfig};
    }

    onTriggerHash= (container) => {
        let config = this.getConfig(container);
        if(config.click) container.click();
        if(config.scroll) container.scrollIntoView({behavior:'smooth'});
        //if(callback) callback(container);
    }

    initContainer = (container) =>  {
        let hash = container.getAttribute(this.attrNames.container);
        if(window.location.hash == hash) this.onTriggerHash(container);

    };
}
